import "./App.css";
import Dmain from "./Desktop/D_main";
import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import fetchJSON from "./fetchData";
import YearList from "./Desktop/YearList";
import _ from "lodash";

export default class App extends Component {
  constructor(props) {
    super(props);
    var today = new Date(),
      today_month = today.getMonth() + 1;
    this.id = this.props.id_AVN_User;

    this.state = {
      id_a_year: YearList[4].id,
      current_id_months: today_month,
      User_role: null,
      User_id_kafedra_otdel: [],
      id_AVN_User: this.props.id_AVN_User,
      user_fio: this.props.user_fio,
      doljnost: this.props.doljnost,
      Timesheet_report: this.props.Timesheet_report,
      is_admin: this.props.AVN20,
      // selected_menu: 0,
      formed: false,
      id_kafedra: 0,
      id_kassa: 0,
      statuss: 0,
      statusS: 0,
      holi_type: "const",
      timesheet_visible: false,
      User_Info: [],
      GlavaVuza: [],
      MonthList: [],
      Kafedry: [],
      YearList: [],
      DimDate: [],
      TimesheetPPS: [],
      Type_day: [],
      TimesheetPosts: [],
      TimesheetUsers: [],
      Teacher_List: [],
      Kafedra_Otdel: [],
      TimesheetManager: [],
      TeacherListALL: [],
      TimesheetMovement: [],
      ForSignatureList: [],
      ApprovedDocList: [],
      BuhDocumentList: [],
      Holydays: [],
    };
  }
  //----------------------------------componentDidMount----------------------------------------//
  componentDidMount() {
    this.postChekUSerRole(this.props.id_AVN_User);
    this.getGlavaVuza();
    this.getAcademYear();
    this.getMonths();
    this.getType_day();
    this.ChangeYear(this.state.id_a_year, "20" + this.state.id_a_year);
  }

  //----------------------------------postChekUSerRole----------------------------------------//
  postChekUSerRole = async (id_AVN_User) => {
    const json = await fetchJSON("check_role", this.id, { id_AVN_User });
    const role = json?.User_Info[0]?.length && json?.User_Info[0][0].dol;
    const sel_menu =
      role == "Составитель" || (this.props.AVN20 > 0 && role == "Составитель")
        ? 1
        : this.props.AVN20 == 0 && role == "Руководитель"
        ? 6
        : this.props.AVN20 > 0
        ? 3
        : this.props.Timesheet_report == 1
        ? 7
        : 0;
    const statuss =
      json?.User_Info &&
      json?.User_Info[0]?.length &&
      json.User_Info[0][0]?.statuss;

    this.setState({
      User_Info: json.User_Info && json.User_Info[0],
      User_role: role,
      User_id_kafedra_otdel:
        json?.User_Info && json?.User_Info[0]?.length && json.User_Info[0],
      selected_menu: sel_menu,
      statuss: statuss ? statuss : 0,
      role,
    });
    this.Select_menu(sel_menu);
  };

  //----------------------------------Ректор ВУЗА----------------------------------------//
  getGlavaVuza = async () => {
    const json = await fetchJSON("glava_vuz", this.id, {});
    this.setState({
      GlavaVuza: json.GlavaVuza && json.GlavaVuza[0],
    });
  };
  //----------------------------------AcademYear----------------------------------------//
  getAcademYear = async () => {
    //----------------------------------RatingYears----------------------------------------//
    const json = await fetchJSON("correntyear", this.id, {});
    this.setState({
      CorrYear: json.CorrYear,
      CorrYearfetch: true,
    });
  };
  //----------------------------------Month----------------------------------------//
  getMonths = async () => {
    const json = await fetchJSON("months", this.id, {});
    this.setState({
      MonthList: json.MonthList && json.MonthList[0],
    });
    if (json.MonthList && json.MonthList.length) {
      let CorrentMonth = json.MonthList[0].filter((item) => {
        return item.id_months == this.state.current_id_months
          ? item.months
          : null;
      });
      this.ChangeMonth(this.state.current_id_months, CorrentMonth[0].months);
    }
  };
  //----------------------------------Timesheet_visible----------------------------------------//
  postTimesheetVisible = async (id_a_year, id_months) => {
    const json = await fetchJSON("timesheet_visible", this.id, {
      id_a_year,
      id_months,
    });
    this.setState({
      timesheet_visible:
        json?.timesheet_visible[0] && json.timesheet_visible[0][0]?.statusDay,
    });
  };
  //----------------------------------TimesheetPPS----------------------------------------//
  postTimesheetPPS = async (
    id_a_year,
    id_months,
    id_kafedra_otdel,
    statuss,
    id_AVN_User,
    timesheet_number,
    visible
  ) => {
    const json = await fetchJSON("timesheet", this.id, {
      id_a_year,
      id_months,
      id_kafedra_otdel,
      statuss,
      id_AVN_User,
      timesheet_number,
      visible,
    });

    if (json.TimesheetPPS && json.TimesheetPPS.length) {
      const Group_TimesheetPPS = _.chain(
        json.TimesheetPPS[1] ? json.TimesheetPPS[1] : json.TimesheetPPS[0]
      )
        .groupBy("id_timesheet_owner_bk_pin")
        .map((value, key) => ({
          id_timesheet_owner: value[0].id_timesheet_owner_bk_pin,
          timesheet_number: value[0].timesheet_number,
          s_t_fio: value[0].s_t_fio,
          post: value[0].post,
          id_post: value[0].id_post,
          INN: value[0].INN,
          b_stavka: value[0].b_stavka,
          k_stavka: value[0].k_stavka,
          work: value[0].work,
          b: value[0].b,
          k: value[0].k,
          ot: value[0].ot,
          p: value[0].p,
          arr: value,
        }))
        .sortBy("s_t_fio")
        .value();

      this.postTimesheetMovement(
        Group_TimesheetPPS &&
          Group_TimesheetPPS.length &&
          Group_TimesheetPPS[0].timesheet_number
      );
      setTimeout(() => {
        this.setState({
          TimesheetPPS: Group_TimesheetPPS,
        });
      }, 100);
    }
  };

  //----------------------------------Type_day----------------------------------------//
  getType_day = async () => {
    const json = await fetchJSON("day_type", this.id, {});
    this.setState({
      Type_day: json.Type_day && json.Type_day[0],
    });
  };

  //----------------------------------SELECTORS----------------------------------------//

  Select_menu = (selected_menu) => {
    this.postKafedra_Otdel(this.state.statuss);
    this.ChangeYear(YearList[4].id, "20" + YearList[4].id);
    this.setState({
      selected_menu,
    });
    if (selected_menu === 2) {
      this.postTimesheetPosts();
    }
    /*************************** */
    if (selected_menu === 3) {
      this.postTimesheetPosts();
      this.postTimesheetUsers(this.state.statuss);
    }
    if (selected_menu === 4) {
      this.postTimesheetManager(this.state.statuss);
      this.postTimesheetPosts();
      this.postTeacher_List_All();
    }
    /*************************** */
    if (selected_menu === 5) {
      this.postTimesheetManager(this.state.statuss);
    }
    if (selected_menu === 6) {
      this.postForSignatureList();
      this.postApprovedDocList(
        this.state.id_a_year,
        this.state.id_months,
        this.state.statuss
      );
    }
    if (selected_menu === 7) {
      this.postDocumentListBuh(
        this.state.id_a_year,
        this.state.id_months,
        this.state.statuss
      );
      this.ChangeKaf_Otdel(null, null);
    }
    if (selected_menu === 8) {
      this.postHolidays("const");
    }
  };
  ChangeYear = (id_a_year, year) => {
    this.setState({ id_a_year, year });
    if (this.state.selected_menu === 7) {
      this.postDocumentListBuh(
        id_a_year,
        this.state.id_months,
        this.state.statusS
      );
    }
    if (this.state.selected_menu === 8) {
      this.postHolidays("dinamic", "20" + id_a_year);
    }
    this.ChangeMonth();
  };
  ChangeMonth = (id_months, months) => {
    if (this.state.selected_menu === 1) {
      this.postTimesheetVisible(this.state.id_a_year, id_months);
    }
    this.setState({ id_months, months });
    if (id_months > 0 && this.state.selected_menu !== 7) {
      this.postDimDate(this.state.id_a_year, id_months);
      this.postTimesheetPPS(
        this.state.id_a_year,
        id_months,
        this.state.id_kafedra_otdel,
        this.state.statuss,
        this.state.id_AVN_User,
        null,
        this.state.timesheet_visible
      );
    }
    if (this.state.selected_menu === 6) {
      this.postForSignatureList();
      this.postApprovedDocList(
        this.state.id_a_year,
        id_months,
        this.state.statusS
      );
    }
    if (this.state.selected_menu === 7) {
      // this.postForSignatureList()
      // this.postApprovedDocList(this.state.id_a_year, id_months, this.state.statusS)
      this.postDocumentListBuh(
        this.state.id_a_year,
        id_months,
        this.state.statusS
      );
    }
  };
  ChangeKaf_Otdel = (id_kafedra_otdel, kafedra_otdel) => {
    this.setState({ id_kafedra_otdel, kafedra_otdel });
    if (id_kafedra_otdel > 0 && this.state.selected_menu !== 7) {
      this.postTimesheetPPS(
        this.state.id_a_year,
        this.state.id_months,
        id_kafedra_otdel,
        this.state.statuss,
        this.state.id_AVN_User,
        null,
        this.state.timesheet_visible
      );
      this.postTeacher_List(this.state.statuss, id_kafedra_otdel);
    }
    if (this.state.selected_menu === 7 && kafedra_otdel) {
      this.postDocumentListBuh(
        this.state.id_a_year,
        this.state.id_months,
        this.state.statusS
      );
      setTimeout(() => {
        let BuhFilter = this.state.BuhDocumentList?.filter(
          (b) => b.kafedra_otdel == kafedra_otdel
        );
        this.setState({
          BuhDocumentList: BuhFilter,
        });
      }, 200);
    }
  };
  ChangeFaculty = (id_faculty, faculty_name) => {
    this.setState({ id_faculty, faculty_name });
  };
  ChangeDoljnost = (id_doljnost, doljnost_name) => {
    this.setState({ id_doljnost, doljnost_name });
  };
  //----------------------------------DimDate----------------------------------------//
  postDimDate = async (id_a_year, id_months) => {
    const json = await fetchJSON("dim_date", this.id, { id_a_year, id_months });
    this.setState({
      DimDate: json.DimDate,
    });
  };

  /*-------------------------Change____TimesheetPPS-----------------------------------*/
  saveUpdatedTimesheetPPS = async (id_timesheet, times, id_type_day) => {
    const json = await fetchJSON("timesheet_pps_update", this.id, {
      id_timesheet,
      times,
      id_type_day,
    });
    if (json) {
      json.result === 1 &&
        this.postTimesheetPPS(
          this.state.id_a_year,
          this.state.id_months,
          this.state.id_kafedra_otdel,
          this.state.statuss,
          this.state.id_AVN_User
        );
    }
  };

  postTimesheetMovement = async (timesheet_number) => {
    const json = await fetchJSON("timesheet_movement", this.id, {
      timesheet_number,
    });
    this.setState({
      TimesheetMovement: json.TimesheetMovement && json.TimesheetMovement[0],
    });
  };

  toFormTimesheet = async (
    timesheet_number,
    id_kafedra_otdel,
    id_AVN_User,
    statuss
  ) => {
    if (this.state.TimesheetPPS && this.state.TimesheetPPS.length) {
      const json = await fetchJSON("to_form_timesheet", this.id, {
        timesheet_number,
        id_kafedra_otdel,
        id_AVN_User,
        statuss,
      });
      if (json) {
        json.result == "INSERT" || json.result == "UPDATE"
          ? toast.info(`Отчет успешно сформирован!`) &&
            this.postTimesheetPPS(
              this.state.id_a_year,
              this.state.id_months,
              this.state.id_kafedra_otdel,
              this.state.statuss,
              this.state.id_AVN_User
            )
          : toast.error(`Не удалось сформировать отчет!`);
      }

      setTimeout(() => {
        const id_timesheetMovement =
          this.state.TimesheetMovement?.length &&
          this.state.TimesheetMovement.find(
            (m) => m.id_avn_login == id_AVN_User
          ).id_timesheetMovement;
        console.log(
          "id_timesheetMovement",
          id_timesheetMovement,
          this.state.TimesheetMovement
        );

        this.postViewReport(true, id_timesheetMovement, timesheet_number);
        this.postApproveReport(true, id_timesheetMovement, timesheet_number);
      }, 500);
    }
  };
  /*-------------------------TimesheetPosts-----------------------------------*/
  postTimesheetPosts = async () => {
    const json = await fetchJSON("timesheet_posts", this.id, {});
    this.setState({
      TimesheetPosts: json.TimesheetPosts && json.TimesheetPosts[0],
    });
  };

  postTimesheetPostsUpdate = async (timesheet_post, id_timesheet_post) => {
    const json = await fetchJSON("timesheet_posts_update", this.id, {
      timesheet_post,
      id_timesheet_post,
    });
    if (json) {
      json.result
        ? toast.info(`Успешно изменено!`) && this.postTimesheetPosts()
        : toast.error(`Ошибка в изменении!`);
    }
  };

  postTimesheetPostsInsert = async (timesheet_post) => {
    const json = await fetchJSON("timesheet_posts_insert", this.id, {
      timesheet_post,
    });
    if (json) {
      json.result
        ? toast.info(`Успешно добавлено!`) && this.postTimesheetPosts()
        : toast.error(`Ошибка в добавлении!`);
    }
  };

  /*-------------------------TimesheetUsers-----------------------------------*/
  SelectStatusS = (statusS) => {
    this.setState({ statusS });
    if (this.state.selected_menu === 3) {
      this.postTimesheetUsers(statusS);
      this.postKafedra_Otdel(statusS);
    }
    if (this.state.selected_menu === 4) {
      this.postTimesheetManager(statusS);
    }
    if (this.state.selected_menu === 6) {
      this.postForSignatureList();
      this.postApprovedDocList(
        this.state.id_a_year,
        this.state.id_months,
        statusS
      );
    }
    if (this.state.selected_menu === 7) {
      this.postKafedra_Otdel(statusS);
      this.postDocumentListBuh(
        this.state.id_a_year,
        this.state.id_months,
        statusS
      );
      this.ChangeKaf_Otdel(null, null);
    }
  };

  postTimesheetUsers = async (statuss) => {
    const json = await fetchJSON("timesheet_user", this.id, { statuss });
    this.setState({
      TimesheetUsers: json.TimesheetUsers && json.TimesheetUsers[0],
    });
    this.postTeacher_List(statuss, this.state.id_kafedra_otdel);
  };

  postKafedra_Otdel = async (statuss) => {
    const json = await fetchJSON("kafedra_otdel", this.id, { statuss });
    if (
      (this.state.User_role == "Составитель" &&
        this.state.selected_menu === 1) ||
      (this.state.User_role == "Составитель" && this.state.selected_menu === 5)
    ) {
      const Filtered_EducList =
        json.Kafedra_Otdel &&
        json.Kafedra_Otdel[0]?.length &&
        json.Kafedra_Otdel[0].filter((o1) => {
          return this.state.User_id_kafedra_otdel.some((o2) => {
            return o1.id_kafedra_otdel == o2.id_kafedra_otdel;
          });
        });
      setTimeout(() => {
        this.setState({
          Kafedra_Otdel: Filtered_EducList,
        });
      }, 50);
    } else
      this.setState({
        Kafedra_Otdel: json.Kafedra_Otdel && json.Kafedra_Otdel[0],
      });

    setTimeout(() => {
      if (this.state.Kafedra_Otdel?.length == 1) {
        this.ChangeKaf_Otdel(
          this.state.Kafedra_Otdel[0].id_kafedra_otdel,
          this.state.Kafedra_Otdel[0].kafedra_otdel
        );
      }
    }, 100);
  };

  postTeacher_List = async (statuss, id_kafedra_otdel) => {
    const json = await fetchJSON("t_fio", this.id, {
      statuss,
      id_kafedra_otdel,
    });
    this.setState({
      Teacher_List: json.Teacher_List && json.Teacher_List[0],
    });
  };

  ChangeTeacher = (id_teacher, t_fio) => {
    this.setState({ id_teacher, t_fio });
  };

  postTimesheetUsersUpdate = async (
    id_kafedra_otdel,
    id_teacher,
    id_doljnost,
    id_AVN_User,
    id_timesheet_user
  ) => {
    const json = await fetchJSON("timesheet_user_update", this.id, {
      id_kafedra_otdel,
      id_teacher,
      id_doljnost,
      id_AVN_User,
      id_timesheet_user,
    });
    if (json) {
      json.result
        ? toast.info(`Успешно изменено!`) &&
          this.postTimesheetUsers(this.state.statusS)
        : toast.error(`Ошибка в изменении!`);
    }
  };

  postTimesheetUsersInsert = async (
    id_kafedra_otdel,
    id_teacher,
    id_doljnost,
    id_AVN_User,
    statuss
  ) => {
    const json = await fetchJSON("timesheet_user_insert", this.id, {
      id_kafedra_otdel,
      id_teacher,
      id_doljnost,
      id_AVN_User,
      statuss,
    });
    if (json) {
      json?.sms[0].sms == "INSERT"
        ? toast.info(`Успешно добавлено!`) &&
          this.postTimesheetUsers(this.state.statusS)
        : toast.error(json.sms[0].sms);
    }
  };

  postTimesheetUsersDelete = async (id_timesheet_user) => {
    const json = await fetchJSON("timesheet_user_delete", this.id, {
      id_timesheet_user,
    });
    if (json) {
      json.result
        ? toast.info(`Успешно удалено!`) &&
          this.postTimesheetUsers(this.state.statusS)
        : toast.error(`Ошибка в удалении!`);
    }
  };

  /*-------------------------Timesheet_Manager-----------------------------------*/
  postTimesheetManager = async (statuss) => {
    const json = await fetchJSON("timesheet_manager", this.id, {});
    if (json) {
      let FilterManagerArray =
        json.TimesheetManager &&
        json.TimesheetManager[0].filter((item) => item.statuss == statuss);
      setTimeout(() => {
        this.setState({
          TimesheetManager: FilterManagerArray,
        });
      }, 10);
    }
  };

  postTeacher_List_All = async () => {
    const json = await fetchJSON("t_fio_all", this.id, {});
    this.setState({
      TeacherListALL: json.TeacherListALL && json.TeacherListALL[0],
    });
  };

  postTimesheetManagerUpdate = async (
    id_teacher,
    id_timesheet_post,
    id_AVN_user,
    id_timesheet_manager
  ) => {
    const json = await fetchJSON("timesheet_manager_update", this.id, {
      id_teacher,
      id_timesheet_post,
      id_AVN_user,
      id_timesheet_manager,
    });
    if (json) {
      json.result
        ? toast.info(`Успешно изменено!`) &&
          this.postTimesheetManager(this.state.statusS)
        : toast.error(`Ошибка в изменении!`);
    }
  };

  postTimesheetManagerInsert = async (
    id_teacher,
    id_timesheet_post,
    statuss,
    id_AVN_user
  ) => {
    const json = await fetchJSON("timesheet_manager_insert", this.id, {
      id_teacher,
      id_timesheet_post,
      statuss,
      id_AVN_user,
    });
    if (json) {
      json.result
        ? toast.info(`Успешно добавлено!`) &&
          this.postTimesheetManager(this.state.statusS)
        : toast.error(`Ошибка в добавлении!`);
    }
  };

  postTimesheetManagerDelete = async (id_timesheet_manager) => {
    const json = await fetchJSON("timesheet_manager_delete", this.id, {
      id_timesheet_manager,
    });
    if (json) {
      json.result
        ? toast.info(`Успешно удалено!`) &&
          this.postTimesheetManager(this.state.statusS)
        : toast.error(`Ошибка в удалении!`);
    }
  };

  /*-----------------------------Document For subscribe--------------------------------- */
  postForSignatureList = async () => {
    const id_AVN_User = this.props.id_AVN_User;
    const json = await fetchJSON("documents_for_signature", this.id, {
      id_AVN_User,
    });
    if (json) {
      this.setState({
        ForSignatureList:
          json.ForSignatureList.length && json.ForSignatureList[0],
      });
    }
  };
  /*-----------------------------ApprovedDocList--------------------------------- */

  postApprovedDocList = async (id_a_year, id_months, statuss) => {
    const json = await fetchJSON("approved_documents", this.id, {
      id_a_year,
      id_months,
      statuss,
    });
    if (json) {
      this.setState({
        ApprovedDocList: json.ApprovedDocList.length && json.ApprovedDocList[0],
      });
    }
  };

  /*------------------------View______Approve______report----------------------*/
  postViewReport = async (viewed, id_timesheetMovement, timesheet_number) => {
    const json = await fetchJSON("view_report", this.id, {
      viewed,
      id_timesheetMovement,
      timesheet_number,
    });
    if (json) {
      setTimeout(() => {
        this.postForSignatureList();
      }, 60 * 1000);
    }
  };

  postApproveReport = async (
    approved,
    id_timesheetMovement,
    timesheet_number
  ) => {
    const json = await fetchJSON("approve_report", this.id, {
      approved,
      id_timesheetMovement,
      timesheet_number,
    });
    if (json) {
      json.result
        ? toast.info(`Успешно вами подтверждено!`) &&
          this.postTimesheetMovement(timesheet_number) &&
          this.postForSignatureList() &&
          this.postApprovedDocList(
            this.state.id_a_year,
            this.state.id_months,
            this.state.statuss
          )
        : toast.error(`Ошибка в подтверждении!`);
    }
  };

  /*-----------------------------Document For subscribe--------------------------------- */
  postDocumentListBuh = async (id_a_year, id_months, statuss) => {
    const json = await fetchJSON("documentsListBuh", this.id, {
      id_a_year,
      id_months,
      statuss,
    });
    if (json) {
      this.setState({
        BuhDocumentList: json.BuhDocumentList.length && json.BuhDocumentList[0],
      });
    }
  };

  /*-------------------------Holidays-----------------------------------*/
  SelectStatusHoliday = (holi_type) => {
    this.setState({ holi_type });
    this.postHolidays(holi_type, "20" + this.state.id_a_year);
  };

  postHolidays = async (type, years) => {
    const json = await fetchJSON("holidays", this.id, { type, years });
    this.setState({
      Holydays: json.Holydays && json.Holydays[0],
    });
  };

  postHolidaysUpdate = async (
    type,
    day,
    month,
    holi_name,
    date,
    id_AVN_User,
    id_holiday
  ) => {
    const json = await fetchJSON("holidays_update", this.id, {
      type,
      day,
      month,
      holi_name,
      date,
      id_AVN_User,
      id_holiday,
    });
    if (json) {
      json.result
        ? toast.info(`Успешно изменено!`) &&
          this.postHolidays(type, "20" + this.state.id_a_year)
        : toast.error(`Ошибка в изменении!`);
    }
  };

  postHolidaysInsert = async (
    type,
    day,
    month,
    holi_name,
    date,
    id_AVN_User
  ) => {
    const json = await fetchJSON("holidays_insert", this.id, {
      type,
      day,
      month,
      holi_name,
      date,
      id_AVN_User,
    });
    if (json) {
      json.result
        ? toast.info(`Успешно добавлено!`) &&
          this.postHolidays(type, "20" + this.state.id_a_year)
        : toast.error(`Ошибка в добавлении!`);
    }
  };

  postHolidaysDelete = async (type, id_holiday) => {
    const json = await fetchJSON("holidays_delete", this.id, {
      type,
      id_holiday,
    });
    if (json) {
      json.result
        ? toast.info(`Успешно удалено!`) &&
          this.postHolidays(type, "20" + this.state.id_a_year)
        : toast.error(`Ошибка в удалении!`);
    }
  };
  render() {
    const {
      Kafedry,
      MonthList,
      Type_day,
      TimesheetPosts,
      GlavaVuza,
      User_Info,
    } = this.state;
    if (
      User_Info &&
      User_Info == null &&
      Kafedry &&
      Kafedry === null &&
      MonthList &&
      MonthList === null &&
      Type_day &&
      Type_day === null &&
      TimesheetPosts &&
      TimesheetPosts === null &&
      GlavaVuza &&
      GlavaVuza === null
    )
      return null;
    else {
      return (
        <div className="App">
          <ToastContainer autoClose={5000} position="bottom-left" />
          <Dmain
            {...this.state}
            {...this.props}
            Select_menu={this.Select_menu.bind(this)}
            ChangeYear={this.ChangeYear.bind(this)}
            ChangeMonth={this.ChangeMonth.bind(this)}
            ChangeFaculty={this.ChangeFaculty.bind(this)}
            saveUpdatedTimesheetPPS={this.saveUpdatedTimesheetPPS.bind(this)}
            toFormTimesheet={this.toFormTimesheet.bind(this)}
            postTimesheetPostsUpdate={this.postTimesheetPostsUpdate.bind(this)}
            ChangeDoljnost={this.ChangeDoljnost.bind(this)}
            SelectStatusS={this.SelectStatusS.bind(this)}
            ChangeKaf_Otdel={this.ChangeKaf_Otdel.bind(this)}
            ChangeTeacher={this.ChangeTeacher.bind(this)}
            postTimesheetPPS={this.postTimesheetPPS.bind(this)}
            postTimesheetUsersUpdate={this.postTimesheetUsersUpdate.bind(this)}
            postTimesheetPostsInsert={this.postTimesheetPostsInsert.bind(this)}
            postTimesheetUsersInsert={this.postTimesheetUsersInsert.bind(this)}
            postTimesheetUsersDelete={this.postTimesheetUsersDelete.bind(this)}
            postTimesheetManagerUpdate={this.postTimesheetManagerUpdate.bind(
              this
            )}
            postTimesheetManagerInsert={this.postTimesheetManagerInsert.bind(
              this
            )}
            postTimesheetManagerDelete={this.postTimesheetManagerDelete.bind(
              this
            )}
            SelectStatusHoliday={this.SelectStatusHoliday.bind(this)}
            postHolidaysUpdate={this.postHolidaysUpdate.bind(this)}
            postHolidaysInsert={this.postHolidaysInsert.bind(this)}
            postHolidaysDelete={this.postHolidaysDelete.bind(this)}
            postViewReport={this.postViewReport.bind(this)}
            postApproveReport={this.postApproveReport.bind(this)}
            postDimDate={this.postDimDate.bind(this)}
          />
        </div>
      );
    }
  }
}
